import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const formTypeService = {
    getAll,
    getAllFormTypes,
    addFormType,
    updateFormType,
    deleteFormType,
};

async function getAll(limit, offset, search_term, sort_column, sort_direction) {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    
    const response = await fetch(
        `${config.oat_api_url}/manage/form-types/getAllFormTypes/?limit=${limit}&offset=${offset}&search_term=${search_term}&sort_column=${sort_column}&sort_direction=${sort_direction}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAllFormTypes() {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/form-types/getAll/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function addFormType(newFormType) {
    const configOptions = {
        method: "POST",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(newFormType),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/form-types/add/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function updateFormType(formTypeItem, formTypeId) {
    const configOptions = {
        method: "PUT",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(formTypeItem),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/form-types/update/${formTypeId}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function deleteFormType(id) {
    const configOptions = {
        method: "DELETE",
        headers: {
        ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        "Content-Type": "application/json",
        },
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/form-types/delete/${id}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}
